import {
  PENGELOLAAN_KINERJA_GPK_PEGAWAI_PATH,
  PENGELOLAAN_KINERJA_GPK_TIM_KINERJA_PATH,
} from 'app/KinerjaShared/constants/path'

import type { TStatePelaksanaan } from 'types/kinerja-pelaksanaan'

export const PRAKTIK_KINERJA_STEP_ORDER: Array<TStatePelaksanaan> = [
  'DOCUMENT_PREPARATION',
  'OBSERVATION_IMPLEMENTATION',
  'DOCUMENT_FOLLOW_UP',
  'FOLLOW_UP_EVALUATION',
  'DOCUMENT_REFLECTION_FOLLOW_UP',
  'REFLECTION_FOLLOW_UP_EVALUATION',
  'COMPLETED',
]

export const PRAKTIK_KINERJA_STEPS: Record<
  TStatePelaksanaan,
  {
    title: string
    imagePath: string
    getPath: (...args: unknown[]) => string
    resetMessage: {
      pegawai: string
      tk: string
    }
  }
> = {
  DOCUMENT_PREPARATION: {
    title: 'Diskusi Persiapan',
    imagePath: '/illustrations/img-document-penci-fill.png',
    getPath: () =>
      `${PENGELOLAAN_KINERJA_GPK_PEGAWAI_PATH}/pelaksanaan/praktik-kinerja/persiapan`,
    resetMessage: {
      pegawai: 'Pengisian akan dihapus',
      tk: 'Pengisian akan dihapus',
    },
  },
  OBSERVATION_IMPLEMENTATION: {
    title: 'Hasil Observasi Praktik Kinerja',
    imagePath: '/illustrations/img-observation-class-check.png',
    getPath: () =>
      `${PENGELOLAAN_KINERJA_GPK_PEGAWAI_PATH}/pelaksanaan/praktik-kinerja/observasi`,
    resetMessage: {
      pegawai: 'Rating Tim Kinerja akan dihapus',
      tk: 'Rating Tim Kinerja akan dihapus',
    },
  },
  DOCUMENT_FOLLOW_UP: {
    title: 'Rencana Tindak Lanjut',
    imagePath: '/illustrations/img-document-interaction-discussion.png',
    getPath: () =>
      `${PENGELOLAAN_KINERJA_GPK_PEGAWAI_PATH}/pelaksanaan/praktik-kinerja/rencana-tindak-lanjut`,
    resetMessage: {
      pegawai: 'Pengisian akan dihapus',
      tk: 'Hasil penilaian Tim Kinerja akan dihapus',
    },
  },
  FOLLOW_UP_EVALUATION: {
    title: 'Dokumen Penilaian Tindak Lanjut',
    imagePath: '/illustrations/img-document-interaction-discussion.png',
    getPath: (ptkId: string) =>
      `${PENGELOLAAN_KINERJA_GPK_TIM_KINERJA_PATH}/pelaksanaan/pemantauan/${ptkId}/praktik-kinerja/rencana-tindak-lanjut`,
    resetMessage: {
      pegawai: 'Pengisian akan dihapus',
      tk: 'Hasil penilaian Tim Kinerja akan dihapus',
    },
  },
  DOCUMENT_REFLECTION_FOLLOW_UP: {
    title: 'Refleksi dan Evaluasi Tindak Lanjut',
    imagePath: '/illustrations/img-document-progress-bar-check.png',
    getPath: () =>
      `${PENGELOLAAN_KINERJA_GPK_PEGAWAI_PATH}/pelaksanaan/praktik-kinerja/refleksi`,
    resetMessage: {
      pegawai: 'Pengisian akan dihapus',
      tk: 'Hasil penilaian Tim Kinerja akan dihapus',
    },
  },
  REFLECTION_FOLLOW_UP_EVALUATION: {
    title: 'Dokumen Penilaian Refleksi Tindak Lanjut',
    imagePath: '/illustrations/img-document-progress-bar-check.png',
    getPath: (ptkId: string) =>
      `${PENGELOLAAN_KINERJA_GPK_TIM_KINERJA_PATH}/pelaksanaan/pemantauan/${ptkId}/praktik-kinerja/refleksi`,
    resetMessage: {
      pegawai: 'Hasil penilaian Tim Kinerja akan dihapus',
      tk: 'Hasil penilaian Tim Kinerja akan dihapus',
    },
  },
  COMPLETED: {
    title: '',
    imagePath: '',
    getPath: () => '',
    resetMessage: {
      pegawai: '',
      tk: '',
    },
  },
}

export const PRAKTIK_KINERJA_RESETABLE_STEP_ORDER: Array<TStatePelaksanaan> = [
  'DOCUMENT_PREPARATION',
  'OBSERVATION_IMPLEMENTATION',
  'DOCUMENT_FOLLOW_UP',
  'DOCUMENT_REFLECTION_FOLLOW_UP',
]
